export const PORTFOLIO_ID = 'PORTFOLIO_ID';


export function set_pf_id(pf_id) {
  return {
    type: PORTFOLIO_ID,
    payload: pf_id
  };
}



// WEBPACK FOOTER //
// ./src/actions/portfolio.js